export const theme = {
  colors: {
    primary: "#E11D48",
    secondary: "#FB7185",
    accent: "#F59E0B",
    background: "#F8FAFC",
    surface: "#FFFFFF",
    surfaceAlt: "#FFF1F2",
    highlight: "#FDE68A",
    text: "#0F172A",
    textSecondary: "#64748B",
    muted: "#94A3B8",
    transition: "#FFF1F2",
    border: "#E2E8F0",
    success: "#16A34A",
    warning: "#D97706",
  },
  fonts: {
    body: "Manrope, Poppins, sans-serif",
    heading: "Sora, Manrope, sans-serif",
  },
};
